import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AdminItemHelpModal extends Component {
  render() {
    const { toggleAdminItemHelp, showAdminItemHelp } = this.props;
    const closeBtn = (
      <button className="close" onClick={toggleAdminItemHelp}>
        <FontAwesomeIcon icon="times" className="fa-fw text-white" />
      </button>
    );
    return (
      <Modal
        isOpen={showAdminItemHelp}
        toggle={toggleAdminItemHelp}
        className={this.props.className}
        size={"md"}
        fade={false}
      >
        <ModalHeader
          toggle={toggleAdminItemHelp}
          className="bg-secondary text-white"
          close={closeBtn}
        >
          <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
          Administrative Item
        </ModalHeader>
        <ModalBody>
          <p>
            An <b>administrative item</b> is a bid item that handles contract
            administration tasks such as progress schedule or time-related overhead, and
            does not have any field-measurable or observable quantities.
          </p>
          <p>
            Checking this box will allow for direct editing of the "General" location
            quantities, but will set all other location quantities to zero.
          </p>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group">
            <button
              name="cancelIblButton"
              id="cancelIblButton"
              type="button"
              className="btn btn-primary ml-2"
              onClick={toggleAdminItemHelp}
            >
              OK
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AdminItemHelpModal;
